import { useParams } from 'react-router-dom';

import WorldNftEventRoute from './WorldNftEventRoute';
import TradingEventRoute from './TradingEventRoute';

type SingleEventRouteParams = {
  id: string;
};

const SingleEventRoute = () => {
  const { id } = useParams<SingleEventRouteParams>();

  // Route world-nft event to dedicated component with mock data
  if (id === 'world-nft') {
    return <WorldNftEventRoute />;
  }

  // All other events use API-based component
  return <TradingEventRoute />;
};

export default SingleEventRoute;
